// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fields-button {\n  line-height: 1;\n}\n.changed-dot {\n  content: '';\n  display: inline-block;\n  height: 0.6em;\n  width: 0.6em;\n  margin-left: 4px;\n  background: red;\n  border-radius: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
